<template>
  <div style="height: 100%">
    <div ref="plot"></div>
  </div>
</template>
<script>
import Plotly from 'plotly.js-dist'
import { api } from '@/main.js'

function b64ToFloat32 (b64Str) {
  var blob = atob(b64Str)
  var fLen = blob.length / Float32Array.BYTES_PER_ELEMENT
  var dView = new DataView(new ArrayBuffer(Float32Array.BYTES_PER_ELEMENT))
  var fAry = new Float32Array(fLen)
  var p = 0

  for (var j = 0; j < fLen; j++) {
    p = j * 4
    dView.setUint8(0, blob.charCodeAt(p))
    dView.setUint8(1, blob.charCodeAt(p + 1))
    dView.setUint8(2, blob.charCodeAt(p + 2))
    dView.setUint8(3, blob.charCodeAt(p + 3))
    fAry[j] = dView.getFloat32(0, true)
  }
  return fAry
}

function yesterday () {
  var d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

const tab10 = [
  'rgba(31, 119, 180, ',
  'rgba(255, 127, 14, ',
  'rgba(44, 160, 44, ',
  'rgba(214,  39, 40, ',
  'rgba(148, 103, 189, ',
  'rgba(140, 86, 75, ',
  'rgba(227, 119, 194, ',
  'rgba(127, 127, 127, ',
  'rgba(188, 189,  34, ',
  'rgba(23, 190, 207, '
]

export default {
  mounted () {
    // eslint-disable-next-line no-unused-vars
    var layout = {
      title: { text: this.title },
      xaxis: {
        visible: true,
        title: { text: 'Frequency [Hz]' },
        autorange: true,
        type: 'log'
      },
      yaxis: {
        visible: true,
        title: { text: this.yLabel },
        fixedrange: false,
        autorange: true,
        type: 'log'
      },
      dragmode: 'pan',
      legend: {
        x: 1,
        xanchor: 'right',
        y: 1,
        bgcolor: 'rgba(255, 255, 255, 0.5)'
      }
    }
    this.plot = Plotly.newPlot(
      this.$refs['plot'],
      [],
      layout,
      { doubleClick: false, scrollZoom: true, responsive: true, displaylogo: false, modeBarButtonsToRemove: ['toImage'] }
    )

    this.$refs['plot'].on('plotly_legendclick', eventdata => {
      if (this.$refs['plot'].data[eventdata.curveNumber].visible === 'legendonly') {
        Plotly.restyle(this.$refs['plot'], { visible: true }, [eventdata.curveNumber, eventdata.curveNumber + 1, eventdata.curveNumber + 2, eventdata.curveNumber + 3, eventdata.curveNumber + 4])
      } else {
        Plotly.restyle(this.$refs['plot'], { visible: false }, [eventdata.curveNumber + 1, eventdata.curveNumber + 2, eventdata.curveNumber + 3, eventdata.curveNumber + 4])
        Plotly.restyle(this.$refs['plot'], { visible: 'legendonly' }, eventdata.curveNumber)
      }
      return false
    })

    this.updateTraces()
    this.redraw()
  },
  props: ['traces', 'timeRange', 'traceNames', 'yLabel', 'title'],
  data: function () {
    return {
      tiles: [],
      zoom: 0,
      tilesRendered: [],
      plot: null,
      redrawInProgress: 0,
      autoUpdate: false,
      timeStampStart: yesterday().getTime() * 1000,
      timeStampEnd: new Date().getTime() * 1000
    }
  },
  methods: {
    redraw: function () {
      // Not the best solution yet .. need to have an intermediate step where we check whats actually already rendered ...
      // on shift we can remove the first tile and redraw the next afterwards without a hurry .. =)
      // We could even already get lower and higher zoom levels ...
      if (this.redrawInProgress > 0) {
        return
      }
      this.traces.forEach((el, index) => {
        // el is the sensor_trace which we'd like to get.
        // example: '4c11ae6108ac/adxl357_x' <- DEVICE/SENSOR_TRACE

        const tileIdent = 'psd' + '/' + el + '/' + this.timeStampStart + '/' + this.timeStampEnd
        if (tileIdent !== this.tilesRendered[index]) {
          // Tile is not there yet, need to fetch it first:
          // else we don't need to do something!
          this.redrawInProgress += 1
          console.log(tileIdent)
          api.get('/data/' + tileIdent)
            .then(response => {
              // once we have the tile we need to check if it's still required and enter it at the correct position!
              // and update this.tileRendered
              var freqs = response.data.freq

              var data = {
                x: [null, null, null, null, null],
                y: [null, null, null, null, null]
              }
              var i = 0
              response.data.data.forEach(d => {
                data.y[i] = b64ToFloat32(d)
                data.x[i] = freqs
                i += 1
              })
              console.log(data)

              if (this.traceNames !== undefined && this.traceNames[index] !== undefined) {
                data['name'] = ['', '', this.traceNames[index]]
              }
              Plotly.restyle(
                this.$refs['plot'],
                data,
                [index * 5, index * 5 + 1, index * 5 + 2, index * 5 + 3, index * 5 + 4]
              )
              this.tilesRendered[index] = tileIdent
              this.redrawInProgress -= 1
            })
            .catch(error => {
              console.log(error)
              this.redrawInProgress -= 1
            })
        }
      })
    },

    updateTraces: function () {
      if (this.$refs['plot'].data.length > this.traces.length * 5) {
        // too many traces remove some ...
        for (var i = this.$refs['plot'].data.length; i > this.traces.length; i--) {
          Plotly.deleteTraces(this.$refs['plot'], [-5, -4, -3, -2, -1])
          this.tilesRendered.pop()
        }
      } else if (this.$refs['plot'].data.length < this.traces.length * 5) {
        // not enough traces need to add some ...
        for (var j = this.$refs['plot'].data.length; j < this.traces.length; j++) {
          this.tilesRendered.push(['', ''])
          Plotly.addTraces(this.$refs['plot'],
            [
              {
                x: [],
                y: [],
                line: { color: tab10[j] + '1)', width: 2 },
                type: 'scattergl',
                mode: 'lines',
                marker: {
                  size: 2
                },
                connectgaps: false
              }, {
                x: [],
                y: [],
                line: { color: tab10[j] + '0.8)', width: 1 },
                type: 'scattergl',
                mode: 'lines',
                marker: {
                  size: 2
                },
                connectgaps: false,
                showlegend: false
              }, {
                x: [],
                y: [],
                line: { color: tab10[j] + '0.75)', width: 1 },
                type: 'scattergl',
                mode: 'lines',
                marker: {
                  size: 2
                },
                connectgaps: false,
                showlegend: false
              }, {
                x: [],
                y: [],
                line: { color: tab10[j] + '0.5)', width: 1 },
                type: 'scattergl',
                mode: 'lines',
                marker: {
                  size: 2
                },
                connectgaps: false,
                showlegend: false
              }, {
                x: [],
                y: [],
                line: { color: tab10[j] + '0.35)', width: 2 },
                type: 'scattergl',
                mode: 'lines',
                marker: {
                  size: 2
                },
                connectgaps: false,
                showlegend: false
              }
            ]
          )
        }
      }
    }
  },

  watch: {
    traces: function (val) {
      // 1. setup dummy Traces without data!
      this.updateTraces()
      // update the data in the traces
      this.redraw()
    },
    timeRange: function (val) {
      console.log('timeStart changed')
      this.timeStampStart = new Date(val[0]).getTime() * 1000
      this.timeStampEnd = new Date(val[1]).getTime() * 1000
      this.autoUpdate = true
      this.redraw()
    }
  }
}
</script>
